import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material';

export interface PeriodicElement {
  Medicationdescription: string;
  startdate: string;
  enddate: string;
  filldate: string;
  provider: string;
  pharmacy: string;
  status: string;
  Action: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {
    Medicationdescription: 'apomorphine powder', startdate: '01/11/2019', enddate: '01/11/2019', filldate: '01/11/2019',
    provider: 'MAHENDRA R.SANAPATI', pharmacy: 'Med Care Pharmacy LLC- Glasgow', status: 'Provider Review', Action: 'Select'
  },
  {
    Medicationdescription: 'morphine (bulk) 100% powder', startdate: '01/11/2019', enddate: '01/11/2019', filldate: '01/11/2019',
    provider: 'Kavitha', pharmacy: 'Med Care Pharmacy LLC- Glasgow', status: 'Send to Pharmacy', Action: 'Select'
  },
  {
    Medicationdescription: 'apomorphine powder', startdate: '01/11/2019', enddate: '01/11/2019', filldate: '01/11/2019',
    provider: 'Yates,Diane', pharmacy: 'MedOne Pharmacy Services', status: '', Action: 'Select'
  },
  {
    Medicationdescription: 'morphine (bulk) crystals', startdate: '01/11/2019', enddate: '01/11/2019', filldate: '01/11/2019',
    provider: 'Hawkins, Francine', pharmacy: 'Medmark', status: 'Special Print', Action: 'Select'
  },
  {
    Medicationdescription: 'apomorphine powder', startdate: '01/11/2019', enddate: '01/11/2019', filldate: '01/11/2019',
    provider: 'Russell,Williams', pharmacy: 'Med Care Pharmacy Services', status: 'Prescription Printed', Action: 'Select'
  },
  {
    Medicationdescription: 'apomorphine 10 mg/mL subcutaneous cartridge ', startdate: '01/11/2019', enddate: '01/11/2019', filldate: '01/11/2019',
    provider: 'Lester,Linda', pharmacy: 'Med Care Pharmacy LLC- Glasgow', status: 'ePrescribed and Verified', Action: 'Select'
  },


];
@Component({
  selector: 'app-clerk-refill',
  templateUrl: './clerk-refill.component.html',
  styleUrls: ['./clerk-refill.component.css']
})
export class ClerkRefillComponent implements OnInit {
  dataSource = ELEMENT_DATA;
  displayedColumns2: string[] = ['Medicationdescription', 'startdate', 'enddate', 'filldate', 'provider', 'pharmacy',
    'status', 'Action'];

  constructor(
    public dialogRef: MatDialogRef<ClerkRefillComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }



  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}


